export default "__VITE_ASSET__DSbK27eV__"